export const version = "ethers/5.6.9";
//# sourceMappingURL=_version.js.map